import React, { useEffect } from "react";

import { useTokenAuth } from "../../hooks/useTokenAuth";
import { useAppContext } from "../../providers/AppContext";
import ApplicationError from "../ApplicationError";
import AppLoading from "../AppLoading";

type Props = { token: string; onAuthenticated?: () => void };

const LoginSso = ({ token, onAuthenticated }: Props) => {
  const { loginState, decoded } = useTokenAuth(token, "sso");
  const [context] = useAppContext();

  useEffect(() => {
    if (loginState === "completed") {
      onAuthenticated?.();
    }
  }, [loginState, onAuthenticated]);

  if (decoded?.appId != null && decoded.appId !== (context.app?.id ?? "cms")) {
    // token is not for this app, get out of here
    return <ApplicationError />;
  }

  if (loginState === "failed") {
    return <ApplicationError />;
  }

  return <AppLoading />;
};

export default LoginSso;
